import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { CustomersService } from 'src/app/services/customer.service';

@Component({
  selector: 'kt-opportunity-metrics',
  templateUrl: './opportunity-metrics.component.html',
  styleUrls: ['./opportunity-metrics.component.css']
})
export class OpportunityMetricsComponent implements OnInit {

  @Input() customerId: number;
  @Input() isFinancialYear:boolean=false;
  @Input() currentUser:any={};
  @Output() dataLoaded = new EventEmitter<void>(); // Event emitter for data load


  opportunityInStageCurrentData:any[]=[];
  opportunityInStageDueData:any[]=[];
  opportunityFollowUps:any[]=[];
  opportunityTopLostReason:any[]=[];
  dealsWonAndLostYearsLabels:any[]=[];
  dealsWonAndLostPercentageData:any[]=[];
  dealsCreationCountValueData:any={labels:[],data:[]};
  TagsLabels:any[]=[];
  TagsVsValueAndCountData:any={labels:[],data:[]};
  TagsVsValueAndCountWonData:any={labels:[],data:[]};
  TagsVsValueAndCountLostData:any={labels:[],data:[]};
  maxMinOpportunity:any
  latestOpportunity: any;
  loading:boolean=true;
  private loadingSubject = new BehaviorSubject<boolean>(true);
  loading$ = this.loadingSubject.asObservable().pipe(shareReplay(1));;
  TagsLostLabels: any[]=[];
  TagsWonLabels: any[]=[];
  opportunityInStageCurrentLabels: any[]=[];
  opportunityInStageDueLabels: any[]=[];
  TagsLastUpdatedSince: any;
  LastUpdatedSinces: any;
  @Input() currency!: string;

  

  constructor(
    private customerService: CustomersService,
    private cdr: ChangeDetectorRef,

  ) { }

  ngOnInit(): void {

    if (this.customerId && this.customerId > 0) {
      setTimeout(()=>{
        this.fetchOpportunityMetrics();
      },1000)
    }
    
  }

  initializeData(){
  this.opportunityInStageCurrentData=[];
  this.opportunityInStageDueData=[];
  this.opportunityFollowUps=[];
  this.opportunityTopLostReason=[];
  this.dealsWonAndLostYearsLabels=[];
  this.dealsWonAndLostPercentageData=[];
  this.dealsCreationCountValueData={labels:[],data:[]};
  this.TagsLabels=[];
  this.TagsVsValueAndCountData={labels:[],data:[]};
  this.TagsVsValueAndCountWonData={labels:[],data:[]};
  this.TagsVsValueAndCountLostData={labels:[],data:[]};
  this.maxMinOpportunity=[]
  this.latestOpportunity=[];
  this.TagsLostLabels=[];
  this.TagsWonLabels=[];
  this.opportunityInStageCurrentLabels=[];
  this.opportunityInStageDueLabels=[];
  this.TagsLastUpdatedSince=[];
  this.LastUpdatedSinces=[];
  }

  fetchOpportunityMetrics(){
    this.loadingSubject.next(true)
    this.initializeData()
    this.customerService.getOpportunityMetrics(this.customerId,this.isFinancialYear).subscribe({
      next:(res:any)=>{
        const opportunityMetricsData =  res && res.data ? res.data : {};
        this.loadingSubject.next(false);
        this.opportunityFollowUps = opportunityMetricsData.FollowUpDetails || [];
        this.opportunityTopLostReason = opportunityMetricsData.TopLostReason || [];
        this.maxMinOpportunity = (opportunityMetricsData.MaxMinOpportunity && opportunityMetricsData.MaxMinOpportunity.length) ? opportunityMetricsData.MaxMinOpportunity[0] : null;
        this.latestOpportunity = (opportunityMetricsData.LatestOpportunity && opportunityMetricsData.LatestOpportunity.length) ? opportunityMetricsData.LatestOpportunity[0] : null;
        this.TagsLastUpdatedSince = (opportunityMetricsData.TagsLastUpdatedSince && opportunityMetricsData.TagsLastUpdatedSince.length) ? opportunityMetricsData.TagsLastUpdatedSince[0] : null;
        this.LastUpdatedSinces = (opportunityMetricsData.LastUpdatedSinces && opportunityMetricsData.LastUpdatedSinces.length) ? opportunityMetricsData.LastUpdatedSinces[0] : null;
        this.transformCurrentOpportunityInStages(opportunityMetricsData.CurrentOpportunityInStages);
        this.transformDueOpportunityInStages(opportunityMetricsData.DueOpportunityInStages);
        this.transformDealsWonAndLostData(opportunityMetricsData.WonAndLostOpportunity);
        this.transformCreateCountAndValueData(opportunityMetricsData.OpportunitiesCount);
        this.transformTagVsValueAndCountData(opportunityMetricsData.AllOpportunityTags);
        this.transformTagsVsValueAndCountLostData(opportunityMetricsData.LostOpportunityTags);
        this.transformTagsVsValueAndCountWonData(opportunityMetricsData.WonOpportunityTags);
        // this.transformOpportunityTagData(opportunityMetricsData?.MostFrequentlyUsedTags);
        this.dataLoaded.emit()
      },
      error:()=>{
        this.loadingSubject.next(false);
        this.dataLoaded.emit()
      }
    })
  }

  transformCurrentOpportunityInStages(data:any){
    if(!data){
      return;
    }
    data.forEach((element:any) => {
      this.opportunityInStageCurrentLabels.push(
        `${element.Status} ${element.CurrentOpportunityCount} (${(this.currency)} ${(element && element.TotalCurrentOpportunityValue ? element.TotalCurrentOpportunityValue.toLocaleString("en-IN") : '')})`
      );      
      this.opportunityInStageCurrentData.push(element.TotalCurrentOpportunityValue)
    });
    
  }
  transformDueOpportunityInStages(data:any){
    if(!data){
      return;
    }
    data.forEach((element:any) => {
      
      this.opportunityInStageDueLabels.push(
        `${element.Status} ${element.DueOpportunityCount} (${(this.currency)} ${(element && element.TotalDueOpportunityValue ? element.TotalDueOpportunityValue.toLocaleString("en-IN") : '')})`
      );      
      this.opportunityInStageDueData.push(element.TotalDueOpportunityValue)
      
    });
  }

  transformDealsWonAndLostData(data:any){
    if(!data){
      return;
    }
        let WonPercentage:any[]=[]
        let LostPercentage:any[]=[]
        
    data.forEach((element:any)=>{
      this.dealsWonAndLostYearsLabels.push(element.Year)
      WonPercentage.push(element.WonPercentage);
      LostPercentage.push(element.LostPercentage);
    })

    if(this.dealsWonAndLostYearsLabels.length == 1){
      // const firstYear = parseInt(this.dealsWonAndLostYearsLabels[0]) - 1;
      const firstYear = ''
      console.log('data: '+firstYear);
      
      this.dealsWonAndLostYearsLabels.unshift(firstYear);
      WonPercentage.unshift(0);
      LostPercentage.unshift(0)
    }

    this.dealsWonAndLostPercentageData=[
      {
        label:'WON',
        data:WonPercentage,
        color: '#0095ff'
      },
      {
        label:'LOST',
        data:LostPercentage,
        color: '#00e096'
      }
    ]

    
  }

  transformCreateCountAndValueData(data:any){
    if(!data){
      return;
    }
    let OpportunityCount:any[]=[]
    let OpportunityValue:any[]=[]
    let OpportunityLabels:any[]=[]
    data.forEach((element:any)=>{
      OpportunityLabels.push(element.Year)
      OpportunityCount.push(element.OpportunityCount);
      OpportunityValue.push(element.OpportunityValue);
    })

    this.dealsCreationCountValueData={
      labels:OpportunityLabels,
      data:[
        {
          data: OpportunityCount,
          label:'COUNT',
          color: '#0095ff'
        },
        {
          data:OpportunityValue,
          label:'VALUE',
          color: '#00e096'
        }
      ]
    }

  }

  transformTagVsValueAndCountData(data:any){
    if(!data){
      return;
    }
    let AllOpportunityCount:any[]=[]
    let TotalAllOpportunityValue:any[]=[]
    data.forEach((element:any)=>{
      this.TagsLabels.push(element.TagName);
      AllOpportunityCount.push(element.AllOpportunityCount)
      TotalAllOpportunityValue.push(element.TotalAllOpportunityValue)

    })

    if(this.TagsLabels.length==1){
      this.TagsLabels.unshift('');
      AllOpportunityCount.unshift(0);
      TotalAllOpportunityValue.unshift(0);
    }
    this.TagsVsValueAndCountData=[
      {
        data:AllOpportunityCount,
        label:'COUNT',
        color: '#0095ff'
      },
      {
        data:TotalAllOpportunityValue,
        label:'VALUE',
        color: '#00e096'
      }
    ]
  }
  transformTagsVsValueAndCountLostData(data:any){
    if(!data){
      return;
    }
    let OpportunityLostCount:any[]=[]
    let TotalLostOpportunityValue:any[]=[]
    data.forEach((element:any)=>{
      this.TagsLostLabels.push(element.TagName);
      OpportunityLostCount.push(element.OpportunityLostCount)
      TotalLostOpportunityValue.push(element.TotalLostOpportunityValue)

    })

    if(this.TagsLostLabels.length==1){
      this.TagsLostLabels.unshift('');
      OpportunityLostCount.unshift(0);
      TotalLostOpportunityValue.unshift(0);
    }

    this.TagsVsValueAndCountLostData=[
      {
        data:OpportunityLostCount,
        label:'COUNT',
        color: '#0095ff'
      },
      {
        data:TotalLostOpportunityValue,
        label:'VALUE',
        color: '#00e096'
      }
    ]

  }
  transformTagsVsValueAndCountWonData(data:any){
    if(!data){
      return;
    }
    let OpportunityWonCount:any[]=[]
    let TotalWonOpportunityValue:any[]=[]
    data.forEach((element:any)=>{
      this.TagsWonLabels.push(element && element.TagName ? element.TagName : '');
      OpportunityWonCount.push(element && element.OpportunityWonCount ? element.OpportunityWonCount : 0);
      TotalWonOpportunityValue.push(element && element.TotalWonOpportunityValue ? element.TotalWonOpportunityValue : '');
    })

    if(this.TagsWonLabels.length==1){
      this.TagsWonLabels.unshift('');
      OpportunityWonCount.unshift(0);
      TotalWonOpportunityValue.unshift(0);
    }

    this.TagsVsValueAndCountWonData=[
      {
        data:OpportunityWonCount,
        label:'COUNT',
        color: '#0095ff'
      },
      {
        data:TotalWonOpportunityValue,
        label:'VALUE',
        color: '#00e096'
      }
    ]
  }

}
